module.exports = __webpack_public_path__ + "img/1484254800.b0543e54.jpg";